<template>
    <b-container fluid class="">
        <b-container fluid class="shadow-lg">
       <b-row  class="p-2 justify-content-center">

            <b-col  cols="3" class="saleDash m-2 p-4">
          <b-row>
            <b-col cols="3">
              <i class="fas fa-tag fa-3x"></i>
            </b-col>
            <b-col cols="9">
              <b-card-title class="text-right">{{ assignment.name }}</b-card-title>
            </b-col>
          </b-row>

          <b-card-text class="text-right">
            <h6>{{$t('sales.assigns.title')}} - {{ assignment.created_at | moment('DD.MM.YYYY') }}</h6>
          </b-card-text>
      </b-col>
      <b-col cols="3" class="saleDash m-2 p-4">
          <b-row>
            <b-col cols="6">
              <i class="fas fa-chart-line fa-3x"></i>
            </b-col>
            <b-col cols="6">
              <b-card-title class="text-right">{{ $t('sales.users.event.sold')}}:</b-card-title>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="9">
              <b-card-text class="text-right">
                <h3 v-if="assignment.total_sold">{{ assignment.total_sold }}</h3>
                <h3 v-else>0</h3>
              </b-card-text>
            </b-col>
            <b-col cols="3">
              <b-card-text class="total">
                <p style="color: #BCBCBC" v-if="assignment.total">/{{ assignment.total }}</p>
                <p style="color: #BCBCBC" v-else>/0</p>
              </b-card-text>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-progress height="1.5rem" class="w-100">
                <b-progress-bar
                   :value="calculatePercentage(assignment.total_sold,assignment.total)"
                  :label="calculatePercentage(assignment.total_sold,assignment.total)+'%'" 
                ></b-progress-bar>
              </b-progress>
            </b-col>
          </b-row>
      </b-col>
      <b-col  cols="3" class="saleDash m-2 p-4">
            <b-row>
                <b-col cols="3">
                <i class="fas fa-cash-register fa-3x"></i>
                </b-col>
                <b-col cols="9">
                <b-card-title class="text-right">{{ $t('sales.users.event.profit')}}:</b-card-title>
                </b-col>
            </b-row>

            <b-card-text class="text-right">
                <h4>{{ assignment.price * assignment.total_sold }} KM</h4>
            </b-card-text>
        </b-col>
       </b-row>
        </b-container>
        <!-- <b-row class="">
            <b-col cols="12" md="12" class="eventDash p-2 w-100 flex-center flex-column">
                <h4>{{ assignment.name }}</h4>
                <h5>{{$t('sales.assigns.title')}} - {{ assignment.created_at | moment('DD.MM.YYYY') }}</h5>
            </b-col>
        </b-row> -->

        <hr/>
        
        <b-row>
            <b-col cols="12" lg="6">
                <b-row class="">
                    <b-col cols="12" class="">
                        <h5>{{$t('sales.users.event.actions')}}</h5>
                    </b-col>
                </b-row>
                <b-row class="py-2 flex-center">
                    <b-col cols="" class="w-100">
                        <b-btn v-b-modal.sellTickets variant="primary"><span class="fas fa-plus mx-2"></span> {{$t('sales.assigns.button')}}</b-btn>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <hr/>

        <b-row v-if="tickets" class="justify-content-center">
            <b-col cols="12" md="10" lg="8" class="p-4 shadow-lg">
                <events-table position small
                              search-key="code"
                              :items="tickets"
                              :fields="ticketsFields"
                              :actions="$t(actions)"
                              @action="action">
                </events-table>
            </b-col>
        </b-row>

        <b-modal centered
                 no-close-on-backdrop
                 id="sellTickets"
                 title=""
                 hide-footer>
                 <template v-slot:modal-title>
                    {{$t('sales.sell.title')}}
                 </template>
            <b-col md="12">
                <b-form data-vv-scope="sellTickets">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group label-for="saleType"
                                          name="saleType"
                                          class="flex-center flex-column">{{ $t('sales.assigns.modal.type.title') }}
                                <b-form-radio v-model="sale.type" name="saleType" inline value="1">{{ $t('sales.assigns.modal.type.single') }}</b-form-radio>
                                <b-form-radio v-model="sale.type" name="saleType" inline value="2">{{ $t('sales.assigns.modal.type.range') }}</b-form-radio>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group label-for="ticketCode"
                                          v-if="sale.type === '1'">{{ $t('sales.assigns.modal.type.code') }}
                                <b-form-input :state="validateState('sellSingleTickets.ticketCode')"
                                              :class="{'is-invalid': veeErrors.has('sellSingleTickets.ticketCode')}"
                                              v-validate="'required|min:1'" v-model="singleTicket.code"
                                              id="ticketCode" ref="ticketCode" type="number" size="md" name="ticketCode"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('sellSingleTickets.ticketCode') }}</span>
                            </b-form-group>
                        </b-col>


                        <b-col cols="6">
                            <b-form-group label-for="ticketsFrom"
                                          v-if="sale.type === '2'">{{ $t('sales.users.event.modal.from') }}
                                <b-form-input :state="validateState('sellTickets.ticketsFrom')"
                                              :class="{'is-invalid': veeErrors.has('sellTickets.ticketsFrom')}"
                                              v-validate="'required|min:1'" v-model="sale.tickets_from"
                                              id="ticketsFrom" ref="ticketsFrom" type="number" size="md" name="ticketsFrom"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('sellTickets.ticketsFrom') }}</span>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label-for="ticketsTo"
                                          v-if="sale.type === '2'">{{ $t('sales.users.event.modal.to') }}
                                <b-form-input :state="validateState('sellTickets.ticketsTo')"
                                              :class="{'is-invalid': veeErrors.has('sellTickets.ticketsTo')}"
                                              v-validate="'required|min:1'" v-model="sale.tickets_to"
                                              id="ticketsTo" ref="ticketsTo" type="number" size="md" name="ticketsTo"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('sellTickets.ticketsTo') }}</span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="float-right">
                        <b-button v-if="sale.type === '1'" @click.prevent="sellTicket(singleTicket)" type="submit" variant="primary" :disabled="veeErrors.any('sellTickets')">{{ $t('sales.assigns.modal.type.button') }}</b-button>
                        <b-button v-if="sale.type === '2'" @click.prevent="sellTickets()" type="submit" variant="primary" :disabled="veeErrors.any('sellTickets')">{{ $t('sales.assigns.modal.type.button') }}</b-button>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal>

        <!-- <b-modal centered
                 no-close-on-backdrop
                 id="sellSingleTicket"
                 title="Sell a single ticket from this assignment"
                 hide-footer>
            <b-col md="12">
                <b-form @submit.prevent="sellTicket(singleTicket)" data-vv-scope="sellSingleTicket">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group label="Ticket code:"
                                          label-for="ticketCode">
                                <b-form-input :state="validateState('sellSingleTickets.ticketCode')"
                                              :class="{'is-invalid': veeErrors.has('sellSingleTickets.ticketCode')}"
                                              v-validate="'required|min:1'" v-model="singleTicket.code"
                                              id="ticketCode" ref="ticketCode" type="number" size="md" name="ticketCode"></b-form-input>
                                <span class="vvError">{{ veeErrors.first('sellSingleTickets.ticketCode') }}</span>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="float-right">
                        <b-button type="submit" variant="primary" :disabled="veeErrors.any('sellSingleTicket')">Sell</b-button>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal> -->

        <b-modal centered
                 no-close-on-backdrop
                 id="sellTicket"
                 title="">
                 <template v-slot:modal-title>
                    {{$t('sales.sell.titleModal')}}
                </template>
            <b-col md="12">
                <b-form @submit.prevent="sellTicket()">
                    <b-row>
                        <b-col cols="12">
                             <h4>{{$t('sales.sell')}} {{ticketForSale.id}}</h4>
                        </b-col>
                    </b-row>
                    <b-row class="float-right">
                        <b-button type="submit" variant="primary">{{$t('sales.sell.sell')}}</b-button>
                    </b-row>
                </b-form>
            </b-col>
        </b-modal>

        <b-modal centered
                 ref="sellSingleTicket" 
                 @ok="sellTicket(singleTicket)"
                 ok-variant="success"> <template v-slot:modal-title>
                    {{$t('sales.sell.sell')}}
                </template>
            <p class="my-4">{{$t('sales.sell.sell')}}? {{singleTicket.code}}</p>
        </b-modal>

    </b-container>
</template>

<script>
    // @ is an alias to /src

    export default {
        name: 'salesmanAssignment',
        data() {
            return {
                sale: {
                    type: '1',
                },
                printError: ('toast.printError'),
                ticketForSale: {},
                assignment: {},
                tickets: [],
                singleTicket: {},
                ticketsFields: [
                    {
                        key: 'name',
                        labelPath: 'table.sale.name',
                        sortable: true,
                        thClass: 'd-none d-lg-table-cell',
                        tdClass: 'd-none d-lg-table-cell' 
                    },
                    {
                        key: 'date',
                        labelPath: 'table.sale.date',
                        sortable: true,
                        formatter: (value) => this.$moment(value).format("DD.MM.YYYY."),
                        thClass: 'd-none d-lg-table-cell',
                        tdClass: 'd-none d-lg-table-cell' 
                    },
                    {
                        key: 'code',
                        labelPath: 'table.sale.code',
                        sortable: true
                    },
                ],
                actions: {
                    sell: {
                        name: 'hover.sell',
                        icon: 'fas fa-coins'
                    }
                },
            }
        },
         computed: {
        },
        methods: {
            validateState(ref) {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref)
                }
                return null
            },
            calculatePercentage(sold, total) {
                if (sold == 0 || total == 0) {
                    return 0;
                }
                if (parseInt((sold / total) * 100) === 100) {
                    //this.done++;
                }
                return parseInt((sold / total) * 100);
                },
            getAssignment(){
                this.$axios.get('sales/userAssignment',{
                                params: {
                                    id: this.$parent.currentUser.id,
                                    event_id: this.$route.params.event_id,
                                    assignment_id: this.$route.params.assignment_id
                                }
                            }).then(response => {
                if (response.status === 200) {
                    this.assignment = response.data.data;
                }
            })
            },
            getAssignedTickets(){
                this.$axios.get('sales/userAssignment/tickets',{
                                params: {
                                    id: this.$parent.currentUser.id,
                                    event_id: this.$route.params.event_id,
                                    assignment_id: this.$route.params.assignment_id
                                }
                            }).then(response => {
                if (response.status === 200) {
                    this.tickets = response.data.data;
                    this.tickets.forEach(function(obj){ 
                        if(obj.ticket_status_id ===25){ 
                            obj._rowVariant = "warning"; 
                            }
                        else if(obj.ticket_status_id ===22){
                            obj._rowVariant = "info"; }
                    });
                }
            })
            },
            sellTickets(){
                this.$validator.validateAll('sellTickets').then((result) => {
                    if (!result) {
                        this.$toasted.global.err({
                            message : this.$t(this.printError)
                        });
                    }else{
                        this.$axios.post('salesman/sellTickets', {
                                params: {
                                    sale: this.sale,
                                    assignment: this.assignment,
                                    id: this.$parent.currentUser.id
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.sale = response.data.data;
                                this.sale.type = '2';
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                            }else{
                                 this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        }).then(()=> {
                                this.$nextTick(() => {
                                    this.veeErrors.clear();
                                    this.$nextTick(() => {
                                        this.$validator.reset();
                                    });
                                });
                            }
                        );
                    }
                });
            },
            sellModal(item){
                this.singleTicket = item;
                this.$refs.sellSingleTicket.show();
            },
             sellTicket(ticket){
                 this.sale.tickets_from = ticket.code;
                 this.sale.tickets_to = ticket.code;
                        this.$axios.post('salesman/sellTickets', {
                                params: {
                                    sale: this.sale,
                                    assignment: this.assignment,
                                    id: this.$parent.currentUser.id
                                }
                            }
                        ).then(response => {
                            if(response.data.success) {
                                this.sale = response.data.data;
                                this.sale.type = '1';
                                let totalItems = this.tickets.length;
                                let self = this;
                                this.tickets.some(function(ticket, index){
                                    if (self.singleTicket.code === ticket.code && self.tickets[index] != self.tickets[self.tickets.length - 1]){
                                        self.singleTicket = self.tickets[index+1];
                                        return true;
                                    }
                                })
                                this.$toasted.global.success({
                                    message : this.$t(response.data.data.msg)
                                });
                            }else{
                                 this.$toasted.global.err({
                                    message : this.$t(response.data.data.msg)
                                });
                            }
                        })
            },
             action: function (action, item) {
                switch (action) {
                    case 'sell':
                        this.sellModal(item);
                        break;
                }
            },

        },
        created() {
            let self = this;
            this.getAssignment();
            this.getAssignedTickets();
            this.interval = setInterval(function () {
                self.getAssignment();
                self.getAssignedTickets();
            }, 3000);
        },
        destroyed(){
            clearInterval(this.interval);
        },
    };
</script>

<style  lang="scss">
    .sectorsRow{
        height: 30vh;
    }
    .sectorsRow2{
        height: 15vh;
    }

</style>